import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';

import {IonicImageLoaderComponent} from './ionic-image-loader.component';

// No providers on purpose: ImageLoaderService / ImageLoaderConfigService are providedIn 'root' and CoreModule maps
// ImageLoaderService -> ImageLoaderLibService. Re-providing them here gave every lazy module importing this one
// (checkout / success / cancellation via InvoiceDetailsModule) its own unpatched base loader, whose rethrow
// reached PaymashErrorHandler as a raw HttpErrorResponse.
@NgModule({
  declarations: [IonicImageLoaderComponent],
  exports: [IonicImageLoaderComponent],
  imports: [
    IonicModule,
    CommonModule
   ] })
export class IonicImageLoaderModule {
}
